import { isEqual, uniqBy } from 'lodash'
import type { PageRef } from '@wix/editor-platform-sdk-types'
import {
  type EditorSDK,
  type DynamicPageRouterData,
  nonNullable,
} from '@wix/wix-data-client-common-standalone'
import type { RouterConfig } from '@wix/wix-data-client-common'

export const getRoutersByPageRefs = async ({
  editorSdkProxy,
  pageRefs,
}: {
  editorSdkProxy: EditorSDK
  pageRefs: PageRef[]
}): Promise<Array<DynamicPageRouterData>> => {
  const routers = await editorSdkProxy.routers.getAll<RouterConfig>()

  const routersByPageRef = pageRefs
    .map(pageRef =>
      routers.find(({ pages }) => pages.some(p => isEqual(p.pageRef, pageRef))),
    )
    .filter(nonNullable)

  return uniqBy(routersByPageRef, 'prefix')
}
